const ROUTE_CHUNKS: Record<string, () => Promise<unknown>> = {
  '/dashboard/site': () => import('@/pages/Dashboard/Site'),
  '/dashboard/vendas': () => import('@/pages/Dashboard/Vendas'),
  '/dashboard/financeiro': () => import('@/pages/Dashboard/Financeiro'),
  '/imoveis': () => import('@/pages/RealState/ListRealState'),
  '/imoveis/chaves': () => import('@/pages/RealState/Keys'),
  '/imoveis/proprietarios': () => import('@/pages/RealState/Owners'),
  '/imoveis/captacoes': () => import('@/pages/RealState/ListingIntakes'),
  '/clientes': () => import('@/pages/Customers/ListCustomers'),
  '/crm': () => import('@/pages/SalesFunnel/Board'),
  '/chat': () => import('@/pages/Chat'),
  '/contratos': () => import('@/pages/RealState/RentContracts/ListRentContracts'),
  '/financeiro': () => import('@/pages/Financeiro'),
  '/financeiro/recebimentos': () => import('@/pages/Financeiro/Recebimentos'),
  '/studio': () => import('@/pages/Studio'),
  '/blog': () => import('@/pages/Blog/ListPosts'),
  '/documentos/modelos': () => import('@/pages/Documents/Models'),
  '/administracao/imobiliarias': () => import('@/pages/Admin/Companies'),
  '/administracao/agendamentos': () => import('@/pages/Admin/Schedules'),
  '/administracao/saude': () => import('@/pages/Admin/Health'),
  '/administracao/vendas': () => import('@/pages/Admin/Sales')
}

const requested = new Set<string>()

export function prefetchRoute(path: string) {
  const load = ROUTE_CHUNKS[path]
  if (!load || requested.has(path)) return
  requested.add(path)
  load().catch(() => requested.delete(path))
}

export const prefetchHandlers = (path: string) => ({
  onMouseEnter: () => prefetchRoute(path),
  onFocus: () => prefetchRoute(path),
  onTouchStart: () => prefetchRoute(path)
})
